import classnames from 'classnames'

import { TableCell, TableCellProps } from '../../../components/Table'

export interface OptionsTableCellProps extends TableCellProps {
  isHighlighted?: boolean
  isBorderVisible?: boolean
}

export function OptionsTableCell({
  isFirst,
  isLast,
  isHighlighted,
  isBorderVisible = true,
  ...props
}: OptionsTableCellProps) {
  return (
    <TableCell
      {...props}
      className={classnames(props.className, 'h-5 bg-white dark:bg-gray-800', {
        'border-t border-gray-100 group-last:border-b dark:border-gray-700': isBorderVisible,
        'border-l pl-2.5 group-first:rounded-tl group-last:rounded-bl': isFirst,
        'border-r pr-2.5 group-first:rounded-tr group-last:rounded-br': isLast,
        'relative overflow-hidden before:absolute before:top-0 before:block before:h-full before:w-1.5 before:bg-green-300 dark:before:bg-green-400':
          isHighlighted,
        'before:left-0': isHighlighted && isFirst,
        'before:right-0': isHighlighted && isLast,
      })}
    />
  )
}
